import React from 'react';
import './UserDropdown.scss';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SecurityIcon from '@mui/icons-material/Security';
import { Link } from "react-router-dom";
import { useContext } from "react";
import { LogoutContext } from "../../store/LogoutContext";
import { AuthContext } from "../../store/AuthContext";

const UserDropdown = ({ onClose }) => {
    const handleLogout = useContext(LogoutContext);
    const { adminData } = useContext(AuthContext);

    const isAdministrador = Array.isArray(adminData?.tipoUsuario)
        && adminData.tipoUsuario.includes('administrador');
    // Licencias: mismo permiso que la ruta /licenses (administrador o administrativo).
    const puedeVerLicencias = Array.isArray(adminData?.tipoUsuario)
        && (adminData.tipoUsuario.includes('administrador')
            || adminData.tipoUsuario.includes('administrativo'));

    const handleLogoutClick = () => {
        console.log('Logout button clicked');
        handleLogout(); // Llamada a la función handleLogout del contexto
    };

    return (
        <div className="user-dropdown">
            <ul>
                <Link to="/profile" onClick={onClose}>
                    <li>
                        <PersonIcon className="menu-icon" />
                        Mi perfil
                    </li>
                </Link>
                <Link to="/calendar" onClick={onClose}>
                    <li>
                        <CalendarMonthIcon className="menu-icon" />
                        Calendario
                    </li>
                </Link>
                {puedeVerLicencias && (
                    <Link to="/licenses" onClick={onClose}>
                        <li>
                            <SecurityIcon className="menu-icon" />
                            Licencias
                        </li>
                    </Link>
                )}
                {isAdministrador && (
                    <Link to="/config" onClick={onClose}>
                        <li>
                            <SettingsIcon className="menu-icon" />
                            Gestión de usuarios
                        </li>
                    </Link>
                )}
                {isAdministrador && (
                    <Link to="/company" onClick={onClose}>
                        <li>
                            <BusinessIcon className="menu-icon" />
                            Gestionar empresas
                        </li>
                    </Link>
                )}
                {isAdministrador && (
                    <Link to="/ClientPortalConfig" onClick={onClose}>
                        <li>
                            <BusinessIcon className="menu-icon" />
                            Gestionar clientes
                        </li>
                    </Link>
                )}
                <Link to="/login" onClick={handleLogoutClick}>
                    <li>
                        <ExitToAppIcon className="menu-icon" />
                        Logout
                    </li>
                </Link>
            </ul>
        </div>
    );
};

export default UserDropdown;
